import React, {useContext} from 'react'
import {
  Grid,
  FormControl,
  InputLabel,
  TextField,
  MenuItem,
  Select,
  FormHelperText,
} from '@material-ui/core'
import {StepActionContext} from './../../../context/StepAction'
import {useEffect} from 'reactn'

export default function WMemoField({data, onChange, entity_id, tabActive}) {
  const {statuses, getStatuses} = useContext(StepActionContext)

  useEffect(() => {
    getStatuses(entity_id, data)

    // eslint-disable-next-line
  }, [getStatuses, entity_id])

  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <InputLabel id="demo-mutiple-name-label">{data.name}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label={data.name}
          value={data.value}
          onChange={e => {
            onChange(e, data.key)
          }}
        >
          {statuses.data?.statuses?.map(f => {
            return <MenuItem value={f.id}>{f.name}</MenuItem>
          })}
        </Select>
        <FormHelperText>
          {(() => {
            if (
              (tabActive === 'upcoming' && data.is_required) ||
              (tabActive === 'ongoing' && data.is_required_return)
            ) {
              return 'required*'
            } else {
              return 'optional'
            }
          })()}
        </FormHelperText>
      </FormControl>
    </Grid>
  )
}
